import { createAction } from 'redux-actions';
import { http } from 'helpers/axios';
import axios from 'axios';
import union from 'lodash/union';
import assign from 'lodash/assign';
import fileDownload from 'js-file-download';
import { BASE_URL } from 'consts';

export const loading = createAction('@@data/loading');

export const fetchReports = createAction(
  '@@data/fetchReports',
  campaignId => dispatch => {
    dispatch(loading());
    return http
      .get(`/campaigns/${campaignId}?populate=reports`)
      .get('data')
      .get('reports');
  }
);

export const updateReports = createAction(
  '@@data/createReport',
  (campaignId, reports) => dispatch => {
    dispatch(loading());
    return http
      .get(`/campaigns/${campaignId}?populate=reports`)
      .then(({ data }) => {
        // Prepare the campaign for update
        assign(data, { reports: union(data.reports, reports) });
        // Update campaign
        return http
          .put(`/campaigns/${campaignId}?populate=reports`, data)
          .get('data');
      });
  }
);

export const clearReports = createAction('@@data/clearReports');

export const updateProgress = createAction('@@data/updateProgress');

export const downloadReport = createAction(
  '@@data/downloadReport',
  (reportId, reportName, totalBytes) => (dispatch, getState) => {
    dispatch(loading());

    const download = axios.create({
      baseURL: BASE_URL,
      timeout: 3600000, // 1 hour
      headers: {
        authorization: getState().auth.token,
      },
      onDownloadProgress: progressEvent => {
        let percent = Math.round(
          (progressEvent.loaded * 100) / totalBytes || 100
        );
        // bug - felipe
        if (percent === Infinity) {
          percent = 0;
        }
        dispatch(updateProgress(percent));
      },
      responseType: 'blob', // <- if we remove this option, the download file gets corrupted
      xsrfCookieName: '_csrf',
      withCredentials: true,
    });

    return download
      .get(`/files/download/${reportId}`)
      .then(({ data }) => {
        return fileDownload(data, reportName);
      })
      .catch(error => {
        console.log(error);
      });
  }
);

export const deleteReport = createAction(
  '@@data/deleteReport',
  (campaignId, report) => dispatch => {
    dispatch(loading());

    return http
      .get(`/campaigns/${campaignId}?populate=reports`)
      .then(({ data }) => {
        // Find the report index
        const index = data.reports.map(el => el._id).indexOf(report._id);
        if (index >= 0) {
          // Delete the element by index
          data.reports.splice(index, 1);
          // Update campaign
          return http
            .put(`/campaigns/${campaignId}?populate=reports`, data)
            .get('data')
            .get('reports');
        }
        return Promise.resolve(data.reports);
      });
  }
);
